module.exports = __webpack_public_path__ + "img/TRACTOR_PGG CHASSIS_LHD_THUMB.3c2afd35.jpg";